/**
 *  @class
 *  @function CollectionScroll
 */
if (!customElements.get('collection-scroll-lg')) {
    class CollectionScroll extends HTMLElement {
      constructor() {
        super();
  
        this.viewport = this.querySelector('.theme-scroll--inner');
        this.slideWidth = 274;
        this.slidesToScroll = 1;
      }
      connectedCallback() {
        // window.OverlayScrollbarsGlobal.OverlayScrollbars({
        //   target: this,
        //   elements: {
        //     viewport: this.viewport,
        //   }
        // }, {});
  
        this.init();
      }
      init() {
        this.setSlides();
        this.reachedEnd = 0;
  
        if (this.slides.length < 1) {
          return;
        }
        this.nav = this.querySelector('.theme-scroll-nav');
        this.navPrev = this.querySelector('.flickity-prev');
        this.navNext = this.querySelector('.flickity-next');
        this.resizeObserver = new ResizeObserver((entries) => {
          this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
          this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
          this.onNavDisabled();
        }, {
          root: this
        });
        this.debouncedOnScroll = debounce((event) => {
          this.onScroll(event);
        }, 100);
  
        this.setListeners();
        this.centerArrows();
      }
      setSlides() {
        this.slides = this.querySelectorAll('.carousel__slide');
        this.slidesLength = this.slides.length;
        this.lastSlide = this.slides[this.slides.length - 1];
      }
      setListeners() {
        this.nav.addEventListener('click', this.onNavClick.bind(this));
        this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
        this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
        this.resizeObserver.observe(this.slides[0]);
      }
      onScroll() {
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
        this.onNavDisabled();
      }
      onNavClick(e) {
        if (!e.target.matches('.flickity-nav') && !e.target.parentNode.matches('.flickity-nav')) {
          return;
        }

        if (e.target.name == 'next' || e.target.parentNode.name == 'next') {
            this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
        } else if (e.target.name == 'prev' || e.target.parentNode.name == 'prev') {
            this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
        }

        this.viewport.scrollTo({
          left: this.scrollPos,
          behavior: "smooth"
        });
      }
      onNavDisabled() {
        if (this.navPrev) {
          this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
        }
        if (this.navNext) {
          this.navNext.disabled = this.reachedEnd ? 1 : 0;
        }
      }
      centerArrows() {
        let first_cell = this.slides[0],
          max_height = 0,
          image_height = 0;
        if (first_cell.querySelector('.product-card-image')) {
          image_height = first_cell.querySelector('.product-card-image').clientHeight;
        } else if (first_cell.querySelector('.gallery--item')) {
          image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
        }
        if (image_height > 0) {
          this.slides.forEach((item, i) => {
            if (item.clientHeight > max_height) {
              max_height = item.clientHeight;
            }
          });
  
          if (max_height > image_height) {
            let difference = (max_height - image_height) / -2;
  
            this.navPrev.style.transform = 'translateY(' + difference + 'px)';
            this.navNext.style.transform = 'translateY(' + difference + 'px)';
          }
        }
      }
    }
    customElements.define('collection-scroll-lg', CollectionScroll);
}